import { lazy } from 'react';
import reducer from './state/reducers'
import { getStore } from '@AppRedux/store';
import checkAuth from '@Utils/checkAuth';

const store = getStore();

const JobOfferAdd = lazy(() =>
    import('./JobOfferAdd').then(async module => {
        await checkAuth();
        const auth = getStore().getState().auth;
        if (auth.isAuthenticated) {
            store.injectReducer('jobOfferAdd', reducer.addReducer);
            return module;
        }
    })
);

const JobOfferList = lazy(() =>
    import('./JobOfferList').then(async module => {
        await checkAuth();
        const auth = getStore().getState().auth;
        if (auth.isAuthenticated) {
            store.injectReducer('jobOfferList', reducer.listReducer);
            return module;

        }
    })
);

const JobOfferRoutes = [
    {
        label: 'Job Offer',
        path: '/HRAutomation/JobOffer/:mode/:id',
        component: JobOfferAdd,
        exact: true,
        showNav: false,
        public: true,
    },
    {
        label: 'Job Offer',
        path: '/HRAutomation/JobOffer',
        component: JobOfferList,
        icon: 'fa-list',
        exact: true,
        showNav: true,
        public: true,
    }
]

export default JobOfferRoutes;